import { GRADES, fmtS, fmtN } from '../constants';

export default function MispricedStockCard({ s, type, i }) {
  const g = GRADES[s.grade] || GRADES["C"];
  const isOver = type === "over";
  return (
    <a href={`/?t=${s.ticker}`} style={{ display:"grid", gridTemplateColumns:"28px 1fr auto", alignItems:"center", background: i===0?(isOver?"rgba(255,59,48,0.04)":"rgba(0,200,5,0.04)"):"#0F0F0F", border:"1px solid rgba(255,255,255,0.07)", borderLeft:`${i<3?4:2}px solid ${isOver?"#FF3B30":"#00C805"}`, borderRadius:12, padding:"11px 14px", marginBottom:7, textDecoration:"none", color:"inherit", cursor:"pointer", transition:"border-color .15s,box-shadow .15s" }}
      onMouseEnter={e=>{ e.currentTarget.style.borderColor="rgba(201,168,76,0.3)"; e.currentTarget.style.boxShadow="0 0 14px rgba(201,168,76,0.07)"; }}
      onMouseLeave={e=>{ e.currentTarget.style.borderColor="rgba(255,255,255,0.07)"; e.currentTarget.style.boxShadow="none"; }}>
      <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize: i<3?14:13, fontWeight:900, color: i<3?(isOver?"#FF3B30":"#00C805"):"rgba(255,255,255,0.2)", textAlign:"center" }}>#{i+1}</div>
      <div style={{ padding:"0 10px" }}>
        <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:15, fontWeight:800, color:"#fff", lineHeight:1 }}>{s.ticker}</div>
        <div style={{ fontSize:10, color:"rgba(255,255,255,0.38)", margin:"1px 0 3px" }}>{s.name}</div>
        <div style={{ fontSize:11, color:"rgba(255,255,255,0.78)", lineHeight:1.4 }}>{s.reason}</div>
      </div>
      <div style={{ textAlign:"right", flexShrink:0 }}>
        <div style={{ fontFamily:"'Rajdhani',sans-serif", fontSize:18, fontWeight:800, color:isOver?"#FF3B30":"#00C805", lineHeight:1 }}>
          {isOver ? `-${fmtS(s.dollarDownside)}` : `+${fmtS(s.dollarUpside)}`}
        </div>
        <div style={{ fontSize:10, fontWeight:700, color:isOver?"#FF3B30":"#00C805", marginTop:1 }}>
          {isOver ? `-${fmtN(s.percentDownside,1)}%` : `+${fmtN(s.percentUpside,1)}%`}
        </div>
        <span style={{ fontSize:10, fontWeight:800, padding:"2px 7px", borderRadius:5, background:g.bg, color:g.color, marginTop:4, display:"inline-block" }}>{s.grade||"—"}</span>
      </div>
    </a>
  );
}
